import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BankDetails from "../../../../components/_utils/AccountCreationComponents/BankDetails";

import AssociateAccountBankEdit from "../../../Accounts/BeneficiaryEditAccount/AssociateAccountBankEdit";
import ICONS from "../../../../assets/Icons";

const FieldForceBankEdit = ({
  beneLookLoading,
  setBankLookupNext,
  bankLookupNext,
  BenEnableNextButton,
  payload,
  setPayload,
  activeStep,
  panNumber,
  bankIsAchived,
  setBankIsArchived,
  bankIsApproved,
  setBankIsApproved,
  handleNext,
  setBankIsDennied,
  setBankIsRejected,
  bankIsDennied,
  bankIsRejected,
  bankIsPending,
  setBankIsPending,
  setBankShutViewAll,
  bankShutViewAll,
  bankDisableCreateNext,
  setBankDisableCreateNext,
  bankNextButtonEnabled,
  bankAccountType,
  setBankAccountType,
  active,
  setActive,
  newBankMessage,
  setBankNewMessage,
  hideBankBlock,
  setBankHideBlock,
  hideBankCreate,
  setBankHideCreate,
  previousBankID,
  handleNextBank,
  createNewedit,
  setCreateNewEdit,
  bankUnachivedOpenPop,
  setBankUnachivedOpenPop,
  bankAchivedOpenPop,
  setBankAchivedOpenPop,
  timer,
  benebankLookData,
  verifyBankisLoading,
  isIFSCValid,
  setIsBankLinkedAccount,
  isBankLinkedAccount,
}) => {
  const isBankError = useSelector(
    (state) => state.beneAllVerification.isBankError,
  );

  const bankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const bankStatus = useSelector(
    (state) => state.beneAllVerification.verifyBank,
  );

  const services = useSelector((state) => state.refreshToken.services);

  const dispatch = useDispatch();
  const [virtualAccount, setVirtualAccount] = useState(false);
  const [bankNonArchive, setBankNonArchive] = useState(false);

  const [accountAction, setAccountAction] = useState(false);
  const [showAccInfo, setShowAccInfo] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Active");
  const [slideDirection, setSlideDirection] = useState("right");

  const associatedAccountRef = useRef(null);
  const [bankUserInfo, setBankUserInfo] = useState([]);

  let haveAcheived = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "archived";
  });
  let haveApproved = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });
  let haveDennied = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "denied";
  });
  let haveRejected = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "rejected";
  });
  let havePending = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending";
  });
  let haveBlock = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "blocked";
  });

  const [bankVerificationStatus, setBankVerificationStatus] = useState(false);

  useEffect(() => {
    if (benebankLookData?.status) {
      setAccountAction(true);
    }
  }, [benebankLookData]);

  useEffect(() => {
    if (bankAchivedOpenPop || bankUnachivedOpenPop) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [bankAchivedOpenPop, bankUnachivedOpenPop]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      event.stopPropagation();
      if (
        associatedAccountRef.current &&
        !associatedAccountRef.current.contains(event.target)
      ) {
        setShowAccInfo(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [associatedAccountRef]);

  useEffect(() => {
    if (activeStep == 0) {
      if (
        payload.bank_account !== payload.old_bank_account &&
        bankStatus?.status === true
      ) {
        BenEnableNextButton(false);
      }
      if (isBankError == true) {
        BenEnableNextButton(true);
        setCreateNewEdit(true);
      }
      if (
        bankStatus?.verification_details[0].account_exists === "N" &&
        !bankLookData
      ) {
        BenEnableNextButton(false);
        setCreateNewEdit(true);
      }
      if (payload.bank_account == payload.old_bank_account) {
        setCreateNewEdit(false);
        setBankNewMessage(true);
      }
      if (payload.bank_account !== payload.old_bank_account && bankLookData) {
        setCreateNewEdit(true);
      }
      if (!payload.bank_account || !payload.ifsc_code) {
        BenEnableNextButton(true);
      }
    }
  }, [bankLookData, isBankError, bankStatus, payload]);

  useEffect(() => {
    if (activeTab === "Active") {
      setActive(false);
      setBankIsDennied(false);
      setBankIsRejected(false);
      setBankIsApproved(false);
      setBankIsArchived(false);
      setBankIsPending(false);
    } else if (activeTab === "Inactive") {
      setActive(true);
      setBankIsDennied(false);
      setBankIsRejected(false);
      setBankIsApproved(false);
      setBankIsArchived(false);
      setBankIsPending(false);
    }
  }, [activeTab]);

  const ActiveData = () => {
    setActive(false);
    setBankIsDennied(false);
    setBankIsRejected(false);
    setBankIsApproved(false);
    setBankIsArchived(false);
    setBankIsPending(false);
    setBankAccountType({
      type: "",
      id: "",
    });
    setAccountAction(true);
    setBankNonArchive(false);
    setBankNewMessage(true);
    setShowAccInfo(false);
    if (activeTab === "Inactive") setSlideDirection("left");
    setActiveTab("Active");
  };

  const DeactiveData = () => {
    if (activeTab === "Active") setSlideDirection("right");
    setActiveTab("Inactive");

    setActive(true);
    setBankIsDennied(false);
    setBankIsRejected(false);
    setBankIsApproved(false);
    setBankIsArchived(false);
    setBankIsPending(false);
    setBankAccountType({
      type: "",
      id: "",
    });
    setAccountAction(true);
    setBankNonArchive(false);
    setShowAccInfo(false);
    setBankNewMessage(true);
  };

  const addSpacesToNumber = (number) => {
    return number.replace(/(.{4})/g, "$1 ").trim();
  };

  const details =
    !beneLookLoading &&
    benebankLookData?.status === undefined &&
    !isBankError &&
    isIFSCValid &&
    virtualAccount;

  return (
    <div className="beneBank_Main  lg:gap-gap-xl  Qsmd:mx-margin-base">
      <div className=" w-width-full lg:w-width-md">
        {bankAccountType.type === "blocked" &&
        !isBankError &&
        !virtualAccount ? (
          <div className="bene_block_message_text">
            <img
              src={ICONS?.ERROR_WHITE_CIRCLE}
              alt="info"
            />
            <p>To unblock this account, please contact customer support</p>
          </div>
        ) : isBankLinkedAccount && isIFSCValid ? (
          <div className=" flex bg-emphasis p-padding-md mb-margin-md rounded-border-radius-md">
            <p className=" text-text-secondary text-font-xs font-normal ">
              Looks like this bank account is already linked to the PAN
              provided. Please change the provided bank details to proceed.
            </p>
          </div>
        ) : hideBankCreate &&
          !isBankError &&
          !newBankMessage &&
          isIFSCValid &&
          !virtualAccount ? (
          <div className="bene_new_message_text_block">
            <img
              src={ICONS?.ERROR_WHITE_CIRCLE}
              alt="info"
            />
            <p>
              Creating a new account will transform this account into a joint
              account since there are several PANs associated with it and adds
              it to the active accounts for the provided Bank details.
            </p>
          </div>
        ) : createNewedit &&
          !isBankError &&
          isIFSCValid &&
          !virtualAccount &&
          timer &&
          bankVerificationStatus ? (
          <div className=" p-padding-md mb-margin-md rounded-border-radius-md bg-emphasis flex">
            <p className=" text-text-secondary text-font-xs font-normal">
              Updating the bank details will transform this account into a joint
              account since there are several PANs associated with it and adds
              it to the active accounts for the provided bank details.
            </p>
          </div>
        ) : bankNonArchive && !isBankError && isIFSCValid && !createNewedit ? (
          <div className="bank_new_message_text_block_nonarchive"></div>
        ) : null}
        {virtualAccount && isIFSCValid && createNewedit ? (
          <div className=" p-padding-md bg-emphasis rounded-border-radius-md mb-margin-md">
            <p>
              <span className=" text-font-sm text-text-primary font-semibold">
                Virtual Account Detected
              </span>{" "}
              <br />
              <ul className="list-disc px-padding-md pt-padding-sm">
                <li className=" text-font-xs text-text-secondary font-normal">
                  Account could not be verified as it is virtual account
                </li>
              </ul>
            </p>
          </div>
        ) : null}
        <div className="h-fit w-full mb-margin-md">
          <BankDetails
            payload={payload}
            setPayload={setPayload}
            BenEnableNextButton={BenEnableNextButton}
            activeStep={activeStep}
            setVirtualAccount={setVirtualAccount}
            setBankUserInfo={setBankUserInfo}
            setShowAccInfo={setShowAccInfo}
            bankLookupNext={bankLookupNext}
            setBankLookupNext={setBankLookupNext}
            bankVerificationStatus={bankVerificationStatus}
            setBankVerificationStatus={setBankVerificationStatus}
            virtualAccount={virtualAccount}
            isIFSCValid={isIFSCValid}
          />
        </div>
      </div>

      {bankVerificationStatus === true ? (
        <>
          <div className=" w-full mb-margin-sm lg:w-width-md">
            <AssociateAccountBankEdit
              ActiveData={ActiveData}
              DeactiveData={DeactiveData}
              haveAcheived={haveAcheived}
              haveDennied={haveDennied}
              haveBlock={haveBlock}
              haveRejected={haveRejected}
              isApprovedState={benebankLookData?.beneficiary_accounts}
              haveApproved={haveApproved}
              havePending={havePending}
              isActive={active}
              activeTab={activeTab}
              setSlideDirection={setSlideDirection}
              slideDirection={slideDirection}
              setActiveTab={setActiveTab}
              previousId={previousBankID}
              addSpacesToNumber={addSpacesToNumber}
              beneLookLoading={beneLookLoading}
              details={details}
              payload={payload}
              isBankLinkedAccount={isBankLinkedAccount}
              type="field_force"
            />
          </div>
        </>
      ) : (
        <div
          className="dividepan bank_Details_Edit"
          style={{
            visibility: "hidden",
          }}
        ></div>
      )}
    </div>
  );
};
export default FieldForceBankEdit;
